function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "4",
  height: "20",
  viewBox: "0 0 4 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  opacity: ".8",
  fill: "#12002D"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "2",
  cy: "2",
  r: "2",
  transform: "rotate(90 2 2)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "2",
  cy: "10",
  r: "2",
  transform: "rotate(90 2 10)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "2",
  cy: "18",
  r: "2",
  transform: "rotate(90 2 18)"
}))));